<div *ngIf="announcement" class="column" [formGroup]="announcement">
    <div class="block announcement-main">
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <ng-select [items]="announcementTypes"
                               bindLabel="name"
                               bindValue="name"
                               dropdownPosition="bottom"
                               [multiple]="false"
                               [closeOnSelect]="true"
                               placeholder="* Announcement Type"
                               formControlName="announcementTypeCde"
                               name="announcementTypeCde"
                               [readonly]="disabled">
                    </ng-select>
                </div>
            </div>

            <div class="col-md-6">
                <mat-form-field class="form-group base-form">
                    <input matInput trimSpaces formControlName="announcementTitle" class="form-control" placeholder="* Announcement Title"
                           maxlength="140" [readonly]="disabled ? '' : null">
                </mat-form-field>
            </div>

        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <mat-form-field id="effectiveDateFormField" class="half-width date-picker">
                        <input (input)="onStartDateChange($event.target.value)"
                               (onchange)="onStartDateChange($event.target.value)" id="effectiveDate" matInput
                               [min]="minDate" [matDatepicker]="effectiveDatePicker" formControlName="effectiveDate"
                               name="effectiveDate" placeholder="* Effective Date" [disabled]="disabled ? '' : null">
                        <mat-datepicker-toggle matSuffix [for]="effectiveDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #effectiveDatePicker
                                        (selectedChanged)="onStartDateSelected($event)"></mat-datepicker>
                        <mat-hint>yyyy-mm-dd</mat-hint>
                    </mat-form-field>

                    <mat-form-field id="effectiveDateTimeFormField" class="third-width time-picker-announcement">
                        <input matInput id="effectiveDateTime" formControlName="effectiveDateTime" type="time"
                               placeholder="Effective Date time" [disabled]="disabled ? '' : null">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <mat-form-field class="form-group base-form">
                    <textarea matInput trimSpaces class="form-control" style="border: 1px solid #9aa3a8;border-radius: 0.25rem; padding: 10px;"
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="5"
                              cdkAutosizeMaxRows="5"
                              placeholder="* Announcement Text"
                              formControlName="announcementTxt"
                              [readonly]="disabled"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <mat-form-field id="endDateFormField" class="third-width date-picker">
                        <input (input)="onEndDateChange($event.target.value)"
                               (onchange)="onEndDateChange($event.target.value)" id="endDate" matInput [min]="minDate"
                               [matDatepicker]="endDatePicker" formControlName="endDate" name="endDate"
                               placeholder="* End Date" [disabled]="disabled ? '' : null">
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker (selectedChanged)="onEndDateSelected($event)"></mat-datepicker>
                        <mat-hint>yyyy-mm-dd</mat-hint>
                    </mat-form-field>

                    <mat-form-field id="endDateTimeFormField" class="third-width time-picker-announcement">
                        <input matInput id="endDateTime" formControlName="endDateTime" type="time"
                               placeholder="End Date time" [disabled]="disabled ? '' : null">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <mat-form-field class="form-group base-form">
                    <input matInput trimSpaces formControlName="linkUrl" name="linkUrl" placeholder="Link URL"
                           class="form-control" maxlength="250" [readonly]="disabled ? '' : null">
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field class="form-group base-form">
                    <input matInput trimSpaces formControlName="linkTxt" name="linkTxt" placeholder="Link Text"
                           class="form-control" maxlength="250" [readonly]="disabled ? '' : null">
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <mat-form-field class="form-group base-form">
                <input matInput trimSpaces formControlName="releaseNumber" name="releaseNumber" placeholder="Release Number"
                       class="form-control" maxlength="25" [readonly]="disabled ? '' : null">
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <div *ngIf="userSearchInfo">
                <div class="form-group">
                    <ng-select
                        [items]="userSearchInfo.reportingCenter"
                        bindLabel="name"
                        bindValue="name"
                        dropdownPosition="bottom"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        placeholder="Reporting Center"
                        formControlName="reportingCenters"
                        name="reportingCenters"
                        [readonly]="disabled">
                    </ng-select>
                </div>
            </div>
        </div>
    </div>
</div>
